import React from 'react';
import { X, BookOpen } from 'lucide-react';
import { useQuiz } from '../context/QuizContext';
import { t } from '../i18n';

const PanduanModal = ({ onClose }) => {
  const { lang } = useQuiz();

  const content = lang === 'id' ? [
    { h: 'Cara Membuat Soal', p: 'Pilih tipe soal dari sidebar kiri (Multiple choice, True/False, dsb). Setiap klik akan menambahkan kartu soal baru.' },
    { h: 'Menggunakan Toolbar Simbol', p: 'Fokuskan kursor pada kolom pertanyaan/pilihan, lalu klik simbol matematika/kimia untuk menyisipkannya.' },
    { h: 'Menyisipkan Gambar / Video', p: 'Klik tombol "Insert link Image" atau "Insert link Video" pada toolbar, lalu tempel URL gambar/video (YouTube didukung).' },
    { h: 'Preview & Mode Ujian', p: 'Klik Preview untuk melihat tampilan soal. Klik "Mulai Mode Ujian" untuk mencoba menjawab dan lihat skor otomatis.' },
    { h: 'Export & Import', p: 'Ekspor ke XML (untuk Moodle), PDF, atau DOCX. Import mendukung CSV, DOCX, dan TXT.' },
    { h: 'Draft & Riwayat', p: 'Semua perubahan disimpan otomatis di browser (localStorage). Gunakan "Simpan Draft" untuk menyimpan snapshot ke Riwayat.' },
  ] : [
    { h: 'Creating Questions', p: 'Pick a question type from the left sidebar (Multiple choice, True/False, etc.). Each click adds a new question card.' },
    { h: 'Using the Symbol Toolbar', p: 'Focus a question/option field, then click any math/chemistry symbol to insert it.' },
    { h: 'Inserting Image / Video', p: 'Click "Insert link Image" or "Insert link Video" in the toolbar and paste a URL (YouTube supported).' },
    { h: 'Preview & Exam Mode', p: 'Click Preview to see how the quiz looks. Hit "Start Exam Mode" to actually answer and get an automatic score.' },
    { h: 'Export & Import', p: 'Export to Moodle XML, PDF, or DOCX. Import supports CSV, DOCX, and TXT.' },
    { h: 'Draft & History', p: 'All changes are auto-saved in your browser (localStorage). Use "Save Draft" to store a snapshot to History.' },
  ];

  return (
    <div className="mg-modal-overlay" onClick={onClose}>
      <div className="mg-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 640 }}>
        <div className="mg-modal-head">
          <div className="mg-title" style={{ fontSize: 18, display: 'flex', gap: 8, alignItems: 'center' }}>
            <BookOpen size={20} color="#1e4b8a" /> {t('panduanTitle', lang)}
          </div>
          <button className="mg-close-x" style={{ position: 'static' }} onClick={onClose}><X size={16} /></button>
        </div>
        <div className="mg-modal-body">
          {content.map((c, i) => (
            <div key={i} style={{ marginBottom: 14 }}>
              <div style={{ fontWeight: 700, color: '#1e4b8a', marginBottom: 4 }}>{i+1}. {c.h}</div>
              <div style={{ color: '#374151', lineHeight: 1.6 }}>{c.p}</div>
            </div>
          ))}
        </div>
        <div className="mg-modal-foot">
          <button className="mg-btn ghost" style={{ width: 'auto', padding: '8px 14px' }} onClick={onClose}>{t('close', lang)}</button>
        </div>
      </div>
    </div>
  );
};

export default PanduanModal;
